import React, {useMemo} from "react";
import {observer} from "mobx-react-lite";
import {Dropdown} from "primereact/dropdown";

import appStore from "../storage/AppStore";
import systemStore from "../storage/SystemStore";


const isEmptyValue = (value) => {
    return (
        value === null ||
        value === undefined ||
        value === ""
    );
};


const Select = ({
    value,

    store,
    prop,

    options = [],

    label,
    placeholder,

    onChange,
    onChangeObject,

    optionLabel = "name",
    optionValue = "id",

    valueTemplate = null,
    dropdownIcon = null,
    itemTemplate = null,

    inputId,

    required = false,
    invalid: invalidProp,

    disabled = false,

    small = false,
    notFull = false,

    for_search = false,

    className = "",

    appendTo =
        typeof document !== "undefined"
            ? document.body
            : null,

    ...rest
}) => {

    const storeBound =
        store !== undefined &&
        prop !== undefined;


    const currentValue =
        value !== undefined
            ? value
            : storeBound
                ? store[prop]
                : null;


    const opts = useMemo(() => {
        if (!for_search) {
            return options;
        }

        return [
            {
                [optionValue]: null,
                [optionLabel]:
                    appStore.tr.search_all,
            },
            ...options,
        ];
    }, [
        options,
        for_search,
        optionLabel,
        optionValue,
        appStore.tr.search_all,
    ]);


    const invalid =
        invalidProp ??
        (
            required &&
            storeBound &&
            Boolean(store?.was_validated) &&
            isEmptyValue(currentValue)
        );


    const isDisabled =
        disabled ||
        systemStore.loading;


    const dropdownClassName = [
        !notFull && "w-full",
        small && "p-inputtext-sm",
        invalid && "p-invalid",
        className,
    ]
        .filter(Boolean)
        .join(" ");


    const handleChange = (event) => {
        const nextValue =
            event.value ?? null;


        if (storeBound) {
            store.setProperty(
                prop,
                nextValue
            );
        }


        onChange?.(
            nextValue,
            event
        );


        if (onChangeObject) {
            const selectedObject =
                nextValue === null
                    ? null
                    : options.find(
                        (option) =>
                            option?.[optionValue] ===
                            nextValue
                    ) || null;

            onChangeObject(
                selectedObject,
                event
            );
        }
    };


    return (
        <Dropdown
            {...rest}

            appendTo={appendTo}

            inputId={inputId}

            value={currentValue}
            options={opts}

            optionLabel={optionLabel}
            optionValue={optionValue}

            placeholder={
                placeholder ??
                label
            }

            valueTemplate={valueTemplate}
            itemTemplate={itemTemplate}
            dropdownIcon={dropdownIcon}

            required={required}
            invalid={invalid}

            disabled={isDisabled}

            className={dropdownClassName}

            emptyMessage={
                appStore.tr.not_found
            }

            onChange={handleChange}
        />
    );
};


export default observer(Select);